import { render } from "./CarouselItemViews.vue?vue&type=template&id=6c9c6861&scoped=true"
import script from "./CarouselItemViews.vue?vue&type=script&lang=js"
export * from "./CarouselItemViews.vue?vue&type=script&lang=js"

import "./CarouselItemViews.vue?vue&type=style&index=0&id=6c9c6861&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9c6861"]])

export default __exports__